<div class="hdmui hdmui-m-0 stack-information hdmui-container">
    <header>
        <mat-toolbar class="dialog-toolbar">
            <h2>
                {{ 'DC.STACK_INFORMATION.TITLE' | translate }}
            </h2>
            <button mat-icon-button (click)="close()">
                <mat-icon svgIcon="hdmui:x"></mat-icon>
            </button>
        </mat-toolbar>
    </header>
    <section class="hdmui-content hdmui-p-0">
        @if (dialogData.noStackData) {
            <hdmui-empty-states icon="hdmui:exclamationMarkCircled">
                <hdmui-empty-states-title>
                    {{ 'DC.OPERATION_CARD.NOT_FOUND' | translate }}
                </hdmui-empty-states-title>
                <hdmui-empty-states-description>
                    {{ 'DC.STACK_INFORMATION.NO_STACK_DATA' | translate }}
                </hdmui-empty-states-description>
            </hdmui-empty-states>
        } @else {
            <mat-card appearance="outlined" class="hdmui stack-information__summary hdmui-background-2">
                <div class="hdmui-content hdmui-p-0">
                    <h2 class="hdmui-font-serif stack-information__summary-title hdmui-mt-2 hdmui-mb-0">
                        {{ dialogData.jobFlow.jobId }}
                    </h2>
                    <p class="hdmui-mt-0 hdmui-font-small">{{ dialogData.jobFlow.jobName }}</p>
                </div>
            </mat-card>
            <data-terminal-job-flow-diagram
                [flow]="dialogData.jobFlow"
                [selectedWorkStepId]="dialogData.selectedWorkStepId"
            />
        }
    </section>
</div>
